"use strict";

exports.__esModule = true;
exports.setters = void 0;

var _Identifiers = require("./Identifiers");

var _Props = _interopRequireDefault(require("./Props"));

var _Validators = require("./Validators");

var _setters;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var setters = (_setters = {}, _setters[_Identifiers.GENERAL_IDENTIFIERS.LINK] = function (tag, value, enableValidation) {
  var validator = {
    isValid: true
  };

  if (enableValidation) {
    validator = (0, _Validators.validateFullUrl)(value);
  }

  if (validator.isValid) {
    tag.props[_Props["default"].HREF] = value;
  }

  return validator;
}, _setters[_Identifiers.GENERAL_IDENTIFIERS.OG_TAG] = function (tag, value) {
  tag.props[_Props["default"].CONTENT] = value;
  return {
    isValid: true
  };
}, _setters[_Identifiers.GENERAL_IDENTIFIERS.STANDARD_META] = function (tag, value) {
  tag.props[_Props["default"].CONTENT] = value;
  return {
    isValid: true
  };
}, _setters);
exports.setters = setters;